/* PH_IMPACT_CART_V5 — meal counter in cart drawer + cart page.
   V2 (2026-07-20): fixed self-triggering MutationObserver that froze the page on add-to-cart.
   The observer now disconnects while we mutate, and innerHTML is only written when it changes. */
(function () {
  var MEALS_PER_ITEM = 10; // [10] — set from rescue agreement on activation
  var observers = [];
  var scheduled = false;

  function countItems(root) {
    var total = 0;
    var seen = [];
    root.querySelectorAll('[data-quantity-variant-id], .cart-item').forEach(function (row) {
      var input = row.querySelector('input[name="updates[]"], .quantity__input');
      if (!input || seen.indexOf(input) !== -1) return; // same line can match two selectors; count its quantity once
      seen.push(input);
      var q = parseInt(input.value, 10);
      if (!isNaN(q)) total += q;
    });
    return total;
  }

  function desiredHTML(items) {
    var meals = items * MEALS_PER_ITEM;
    return '<span class="ph-cart-meals__ico" aria-hidden="true">🥣</span><span>This cart funds <strong>' +
      meals + ' meals</strong> for <strong>abandoned cats</strong>.</span>';
  }

  function render(root) {
    if (!root) return;
    // On the cart page, the DOM holds BOTH #main-cart-items and the always-present cart-drawer.
    // Count only this context's items so they are not summed together.
    var scope = (root === document) ? (root.querySelector('#main-cart-items') || root) : root;
    var items = countItems(scope);
    var host = root.querySelector('.cart-drawer__footer, .cart__footer, cart-drawer .drawer__footer');
    if (!host) return;
    var el = host.querySelector('.ph-cart-meals');
    if (items < 1) { if (el) el.hidden = true; return; }
    if (!el) {
      el = document.createElement('div');
      el.className = 'ph-cart-meals';
      host.insertBefore(el, host.firstChild);
    }
    el.hidden = false;
    var html = desiredHTML(items);
    if (el.innerHTML !== html) el.innerHTML = html; // only mutate when it actually changes
  }

  function boot() {
    render(document.querySelector('cart-drawer'));
    if (document.querySelector('#main-cart-footer')) render(document);
  }

  // Run boot() with the observers disconnected so our own DOM writes can't retrigger them.
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      observers.forEach(function (o) { o.disconnect(); });
      try { boot(); }
      finally {
        observers.forEach(function (o) {
          if (o._target && o._target.isConnected) o.observe(o._target, { childList: true, subtree: true });
        });
      }
    };
    (window.requestAnimationFrame || window.setTimeout)(run);
  }

  function watch(target) {
    if (!target) return;
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('.ph-cart-meals')) continue;
        schedule();
        return;
      }
    });
    mo._target = target;
    mo.observe(target, { childList: true, subtree: true });
    observers.push(mo);
  }

  function init() {
    boot();
    watch(document.querySelector('cart-drawer'));
    watch(document.querySelector('#main-cart-items'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('cart:refresh', schedule);
})();
